import { useState } from 'react';

import { AlertProps, Icons } from '@cast/design-system';

import { CloseableAlert } from '../CloseableAlert';

export type ExpandableAlertProps = AlertProps & {
  action?: never;
  alertId: string;
};

type TogglerIconProps = { isExpanded: boolean; onClick: () => void };

const TogglerIcon = ({ isExpanded, onClick }: TogglerIconProps) => {
  const Icon = isExpanded ? Icons.CaretUp : Icons.CaretDown;

  return (
    <Icon
      size={20}
      weight="bold"
      css={({ palette }) => ({
        color: palette.grey[900],
        cursor: 'pointer',
      })}
      onClick={onClick}
      data-testid="expander-icon"
    />
  );
};

export const ExpandableAlert = ({
  children,
  alertId,
  ...alertProps
}: ExpandableAlertProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <CloseableAlert
      {...alertProps}
      closeable={alertId}
      sx={{
        mb: 4,
        '& .MuiAlert-action': {
          paddingTop: 0,
          margin: isExpanded ? '11px 0 0' : 'auto',
        },
        '& .MuiAlert-message': { flexGrow: 1, overflow: 'visible' },
      }}
      icon={
        <TogglerIcon
          isExpanded={isExpanded}
          onClick={() => setIsExpanded(!isExpanded)}
        />
      }
    >
      {isExpanded ? children : null}
    </CloseableAlert>
  );
};
